/* Giveaway page behavior only.
   Does not write into UpCart, the cart page, the cart drawer, or checkout.
   Quick add posts a normal Shopify /cart/add form so the existing cart opens itself.

   Only the promotion that is active right now is present here. The campaign
   calendar is not shipped to the browser. */
(function () {
  if (window.__gw26) return;
  window.__gw26 = true;

  var configNode = document.getElementById('gw26-config');
  var config = {};
  if (configNode) {
    try { config = JSON.parse(configNode.textContent); } catch (e) { config = {}; }
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* Entries for an amount in cents at a given multiplier.
     Mirrors snippets/giveaway-entries.liquid: whole dollars rounded up, as
     the Official Rules specify, then multiplied. */
  function entriesFor(cents, multiplier) {
    return Math.ceil(Number(cents) / 100) * Number(multiplier);
  }

  function tzOffset(utcMs, timeZone) {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
    var parts = fmt.formatToParts(new Date(utcMs));
    var map = {};
    parts.forEach(function (p) { if (p.type !== 'literal') map[p.type] = p.value; });
    var hour = map.hour === '24' ? 0 : Number(map.hour);
    var asUTC = Date.UTC(Number(map.year), Number(map.month) - 1, Number(map.day), hour, Number(map.minute), Number(map.second));
    return asUTC - utcMs;
  }

  function zonedToUtc(iso, timeZone) {
    var m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/);
    if (!m) return null;
    var guess = Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]), Number(m[4]), Number(m[5]), Number(m[6]));
    var utc = guess - tzOffset(guess, timeZone);
    return guess - tzOffset(utc, timeZone);
  }

  function markEnded(root, label) {
    if (root.dataset.gwDone === '1') return;
    root.dataset.gwDone = '1';
    root.textContent = '';
    var p = document.createElement('p');
    p.className = 'gw26-count__ended';
    p.textContent = label || 'This offer has ended.';
    root.appendChild(p);
    root.setAttribute('aria-label', p.textContent);
  }

  function startCountdowns() {
    /* Absolute instants from giveaway-schedule. They are already fixed to
       midnight Eastern, so neither the store's nor the shopper's time zone
       can move them. The wall-clock fields are only read from older markup. */
    var zone = config.timeZone || 'America/New_York';
    function instant(ms, iso) {
      if (typeof ms === 'number' && isFinite(ms)) return ms;
      return zonedToUtc(iso, zone);
    }
    var ends = {
      campaign: instant(config.campaignEndMs, config.campaignEnd),
      promo: instant(config.promoEndMs, config.promoEnd)
    };
    var startMs = instant(config.campaignStartMs, config.campaignStart);
    var roots = document.querySelectorAll('[data-gw-countdown]');
    if (!roots.length) return;
    var statusNodes = document.querySelectorAll('[data-gw-status]');

    function paint() {
      var now = Date.now();
      var live = 0;

      /* The server decides the campaign phase and the hero already states it,
         so this line only has a job on older markup that shipped without a
         resolved phase. Painting it anyway would contradict the hero. */
      if (!config.state && startMs !== null && now < startMs && config.upcomingLabel) {
        statusNodes.forEach(function (node) {
          node.hidden = false;
          node.textContent = config.upcomingLabel;
        });
      } else {
        statusNodes.forEach(function (node) { node.hidden = true; });
      }

      /* Once the campaign deadline passes, stop promising entries even if the
         control panel has not been switched to Ended yet. */
      if (ends.campaign !== null && now >= ends.campaign) {
        document.documentElement.classList.add('gw26-ended');
      }

      roots.forEach(function (root) {
        var kind = root.getAttribute('data-gw-countdown');
        var end = ends[kind];
        if (end === null || end === undefined) return;
        var remain = end - now;
        if (remain <= 0) {
          markEnded(root, kind === 'campaign' ? config.endedLabel : config.promoOverLabel);
          return;
        }
        live += 1;
        var total = Math.floor(remain / 1000);
        var days = Math.floor(total / 86400);
        var hours = Math.floor((total % 86400) / 3600);
        var mins = Math.floor((total % 3600) / 60);
        var secs = total % 60;
        var d = root.querySelector('[data-gw-days]');
        if (!d) return;
        d.textContent = String(days);
        root.querySelector('[data-gw-hours]').textContent = pad(hours);
        root.querySelector('[data-gw-mins]').textContent = pad(mins);
        root.querySelector('[data-gw-secs]').textContent = pad(secs);
        root.setAttribute('aria-label', days + ' days, ' + hours + ' hours, ' + mins + ' minutes, ' + secs + ' seconds remaining');
      });

      return live === 0;
    }

    if (paint()) return;
    var timer = window.setInterval(function () {
      if (paint()) window.clearInterval(timer);
    }, 1000);
  }

  function initCards() {
    document.querySelectorAll('[data-gw-card]').forEach(function (card) {
      var choose = card.querySelector('[data-gw-choose]');
      var opts = card.querySelector('.gw26-opts');
      var form = card.querySelector('.gw26-card__form');
      if (!choose || !opts || !form) return;

      var multiplier = Number(card.getAttribute('data-gw-mult') || 0);
      var showEntries = card.getAttribute('data-gw-entries-on') === 'true';
      var idInput = form.querySelector('[data-gw-id]');
      var addBtn = form.querySelector('[data-gw-add]');
      var price = card.querySelector('[data-gw-price]');
      var entry = card.querySelector('[data-gw-entry]');
      var label = card.querySelector('[data-gw-variant-label]');
      var image = card.querySelector('.gw26-card__media img');

      choose.addEventListener('click', function () {
        opts.hidden = false;
        choose.setAttribute('aria-expanded', 'true');
        var first = opts.querySelector('.gw26-opt:not(:disabled)');
        if (first) first.focus();
      });

      opts.querySelectorAll('[data-gw-option]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          opts.querySelectorAll('[data-gw-option]').forEach(function (btn) {
            btn.setAttribute('aria-pressed', 'false');
          });
          opt.setAttribute('aria-pressed', 'true');

          if (idInput) idInput.value = opt.getAttribute('data-id') || '';
          if (price) price.textContent = opt.getAttribute('data-price') || '';

          if (entry && showEntries && multiplier > 0) {
            var odo = entry.querySelector('[data-gw-odo]');
            var n = entriesFor(opt.getAttribute('data-cents'), multiplier);
            /* Roll from the previous variant's total to the new one. */
            if (odo) rollTo(odo, n);
            var lead = entry.firstChild;
            if (lead && lead.nodeType === 3) lead.textContent = '';
          }

          if (label) {
            label.hidden = false;
            label.textContent = opt.getAttribute('data-label') || '';
          }
          if (image && opt.getAttribute('data-src')) {
            image.src = opt.getAttribute('data-src');
            image.srcset = opt.getAttribute('data-srcset') || '';
          }

          var ok = opt.getAttribute('data-available') === 'true';
          if (addBtn) {
            addBtn.disabled = !ok;
            addBtn.textContent = ok ? 'Quick add' : 'Sold out';
          }
          form.hidden = false;
          choose.hidden = true;
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Motion. Everything here is one-shot and resolves to the real value
     that Liquid already rendered, so a shopper never reads a number the
     server did not produce.
     ------------------------------------------------------------------ */

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmt(n) {
    return Number(n).toLocaleString('en-US');
  }

  /* Count a number element up to `to`. Always ends exactly on `to`. */
  function rollTo(el, to, ms) {
    var target = Number(to) || 0;
    if (reduceMotion) {
      el.textContent = fmt(target);
      return;
    }
    var from = Number(String(el.textContent || '').replace(/[^\d]/g, '')) || 0;
    if (from === target) {
      el.textContent = fmt(target);
      return;
    }
    var dur = ms || 520;
    var start = 0;
    if (el._gwRaf) cancelAnimationFrame(el._gwRaf);

    function step(ts) {
      if (!start) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = fmt(Math.round(from + (target - from) * eased));
      if (t < 1) el._gwRaf = requestAnimationFrame(step);
      else el.textContent = fmt(target);
    }
    el._gwRaf = requestAnimationFrame(step);
  }

  /* Entry totals roll up the first time a card scrolls into view. */
  function initOdometers() {
    var nodes = [].slice.call(document.querySelectorAll('[data-gw-odo]'));
    if (!nodes.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          io.unobserve(el);
          var to = el.getAttribute('data-gw-to');
          if (to === null) return;
          el.textContent = '0';
          rollTo(el, to);
        });
      },
      { threshold: 0.35 }
    );
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* Gauge sweep plus the base-rate override, once, on first view. */
  function initDashboard() {
    var dash = document.querySelector('[data-gw-dash]');
    if (!dash) return;
    var gauge = dash.querySelector('[data-gw-gauge]');
    var arc = dash.querySelector('[data-gw-gauge-arc]');
    var num = dash.querySelector('[data-gw-gauge-num]');
    if (!gauge || !arc) return;

    var mult = Number(gauge.getAttribute('data-gw-mult')) || 0;
    var LEN = 326.73; /* full r=52 circle, matches the CSS dasharray */

    /* The ring always closes, whatever the multiplier is. It reports that
       the current bonus is fully active rather than progress toward a
       larger one, so there is no ceiling to divide by and no remainder
       left on the track for a shopper to read as "more is coming". */
    function closeRing() {
      arc.style.strokeDashoffset = '0';
      dash.classList.add('is-live');
    }

    function showMultiplier() {
      if (num) num.textContent = String(mult);
    }

    if (reduceMotion) {
      closeRing();
      showMultiplier();
      return;
    }

    /* Liquid paints the ring closed and the numeral at its final value so
       both are correct without JavaScript. Wind them both back together as
       soon as the script runs, so the finished state is not left on screen
       flashing until the section scrolls into view. */
    arc.style.strokeDashoffset = String(LEN);

    function run() {
      arc.style.transition = 'stroke-dashoffset 1.05s cubic-bezier(0.2, 0.8, 0.3, 1)';
      closeRing();

      /* The numeral is the active bonus from the first frame. It never
         counts up through lower values, which would read as a meter
         climbing toward something bigger. */
      showMultiplier();

      /* Redline accent, once, as the ring meets itself. */
      window.setTimeout(function () { gauge.classList.add('is-locked'); }, 980);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          run();
        },
        { threshold: 0.3 }
      );
      io.observe(dash);
    } else {
      run();
    }
  }

  /* ------------------------------------------------------------------
     Cart entry HUD. Read-only: it GETs /cart.js and renders a total.
     It never writes to the cart and never touches the cart drawer app.
     ------------------------------------------------------------------ */
  function initCartHud() {
    var hud = document.querySelector('[data-gw-hud]');
    if (!hud) return;
    var mult = Number(hud.getAttribute('data-gw-mult')) || 0;
    var entriesEl = hud.querySelector('[data-gw-hud-entries]');
    var labelEl = hud.querySelector('[data-gw-hud-label]');
    var subEl = hud.querySelector('[data-gw-hud-sub]');
    var ctaEl = hud.querySelector('[data-gw-hud-cta]');
    var last = null;

    function money(cents) {
      return '$' + (Number(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function paint(cents) {
      var n = entriesFor(cents, mult);
      var empty = !cents;
      hud.setAttribute('data-gw-empty', empty ? 'true' : 'false');
      if (labelEl) labelEl.textContent = empty ? 'Your cart' : 'Your cart today';
      if (subEl) {
        subEl.textContent = empty
          ? 'Add qualifying products to start earning.'
          : money(cents) + ' merchandise';
      }
      if (ctaEl) ctaEl.hidden = empty;
      if (entriesEl) {
        if (last !== null && last !== n) {
          hud.classList.remove('is-bumped');
          void hud.offsetWidth;
          hud.classList.add('is-bumped');
        }
        rollTo(entriesEl, n);
      }
      last = n;
    }

    function refresh() {
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          /* items_subtotal_price is merchandise after line discounts. */
          paint(data.items_subtotal_price || 0);
        })
        .catch(function () {});
    }

    refresh();

    /* Re-read after a quick add on this page, and when the tab regains focus
       (covers changes made in the cart drawer without hooking into it). */
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.matches && e.target.matches('.gw26-card__form, .gw26-sheet__form')) {
        window.setTimeout(refresh, 900);
        window.setTimeout(refresh, 2200);
      }
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh();
    });
    window.addEventListener('pageshow', refresh);
  }

  /* ------------------------------------------------------------------
     Kit sheet. The markup and the variant ids come from Liquid and the
     form posts to Shopify's own cart endpoint, so this only handles
     opening and closing.
     ------------------------------------------------------------------ */
  function initKitSheets() {
    document.querySelectorAll('[data-gw-kit-open]').forEach(function (btn) {
      var sheet = document.getElementById(btn.getAttribute('data-gw-kit-open'));
      if (!sheet) return;

      btn.addEventListener('click', function () {
        if (typeof sheet.showModal === 'function') sheet.showModal();
        else sheet.setAttribute('open', '');
        var first = sheet.querySelector('input:checked:not(:disabled)');
        var label = first && first.closest('.gw26-kit');
        if (label) label.scrollIntoView({ block: 'nearest' });
      });

      sheet.addEventListener('close', function () { btn.focus(); });

      sheet.querySelectorAll('[data-gw-kit-close]').forEach(function (x) {
        x.addEventListener('click', function () {
          if (typeof sheet.close === 'function') sheet.close();
          else sheet.removeAttribute('open');
        });
      });

      /* Clicking the backdrop closes it. The form fills the dialog, so a
         hit on the dialog itself is a hit outside the panel. */
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet && typeof sheet.close === 'function') sheet.close();
      });
    });
  }

  function embedUrl(raw) {
    var url;
    try { url = new URL(raw); } catch (e) { return ''; }
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
    var host = url.hostname.replace(/^www\./, '');
    var id = '';
    if (host === 'youtu.be') id = url.pathname.split('/').filter(Boolean)[0] || '';
    else if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'youtube-nocookie.com') {
      id = url.searchParams.get('v') || url.pathname.split('/').filter(Boolean).pop() || '';
    }
    if (id && /^[\w-]{6,}$/.test(id)) return 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
    if (host === 'vimeo.com' || host === 'player.vimeo.com') {
      var vid = url.pathname.split('/').filter(Boolean).pop() || '';
      if (/^\d+$/.test(vid)) return 'https://player.vimeo.com/video/' + vid + '?autoplay=1';
    }
    return '';
  }

  function initVideo() {
    document.querySelectorAll('[data-gw-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var template = btn.nextElementSibling;
        if (template && template.tagName === 'TEMPLATE') {
          btn.replaceWith(template.content.cloneNode(true));
          return;
        }
        var src = embedUrl(btn.getAttribute('data-video-url'));
        if (!src) return;
        var frame = document.createElement('iframe');
        frame.className = 'gw26-video';
        frame.src = src;
        frame.title = 'Giveaway video';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture';
        frame.allowFullscreen = true;
        frame.setAttribute('loading', 'lazy');
        btn.replaceWith(frame);
      });
    });
  }

  function visible(node) {
    if (!node) return false;
    var cs = window.getComputedStyle(node);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
    var rect = node.getBoundingClientRect();
    return rect.width > 8 && rect.height > 8;
  }

  function blockingUiOpen() {
    var selectors = [
      '.upcart-backdrop',
      '.upcart-cart',
      '.upcart-internal-cart-preview',
      '#shopify-pc__banner',
      '.shopify-pc__banner__dialog',
      '#shopify-privacy-banner'
    ];
    var nodes = document.querySelectorAll(selectors.join(','));
    for (var i = 0; i < nodes.length; i++) if (visible(nodes[i])) return true;
    return false;
  }

  function initSticky() {
    var sticky = document.querySelector('[data-gw-sticky]');
    var hero = document.querySelector('.gw26-hero');
    if (!sticky || !hero) return;
    var heroSeen = true;
    var mq = window.matchMedia('(max-width: 989px)');

    function place() {
      var show = mq.matches && !heroSeen && !blockingUiOpen();
      sticky.hidden = !show;
      var h = show ? sticky.offsetHeight : 0;
      var root = document.documentElement;
      root.style.setProperty('--gw-sticky-space', h + 'px');
      /* Drives the fixed-UI offsets so the chat widget and the final CTA
         clear our bar instead of sitting under it. */
      root.style.setProperty('--gw-sticky-h', h + 'px');
      root.classList.toggle('gw26-sticky-on', show);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        heroSeen = entries[0].isIntersecting;
        place();
      }, { threshold: 0 }).observe(hero);
    } else {
      heroSeen = false;
    }

    place();
    window.addEventListener('resize', place);
    document.addEventListener('click', function () { window.setTimeout(place, 60); });
    window.setInterval(place, 700);
  }

  function measureHeader() {
    var header = document.querySelector('[data-site-header]');
    var h = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--gw-header-h', h + 'px');
  }

  measureHeader();
  window.addEventListener('resize', measureHeader);
  startCountdowns();
  initCards();
  initKitSheets();
  initDashboard();
  initOdometers();
  initCartHud();
  initVideo();
  initSticky();
})();
